import React from "react";
import {
  Create,
  Edit,
  TextInput,
  SelectInput,
  ReferenceArrayInput,
  SelectArrayInput
} from "admin-on-rest";
import IconTitle from "../components/icon_title";
import OlaForm from "../components/form/OlaForm";

function userOptionTextFormatter(data) {
  return data.first_name + " " + data.last_name;
}
const AccountForm = props => (
  <OlaForm {...props}>
    <TextInput label="resources.accounts.fieldList.name" source="name" />
    <SelectInput
      label="resources.accounts.fieldList.type.title"
      source="type"
      choices={[
        {
          id: "Brand",
          name: "resources.accounts.fieldList.type.choices.brand"
        },
        {
          id: "Merchant",
          name: "resources.accounts.fieldList.type.choices.merchant"
        },
        {
          id: "Supplier",
          name: "resources.accounts.fieldList.type.choices.supplier"
        },
        {
          id: "Agency",
          name: "resources.accounts.fieldList.type.choices.agency"
        }
      ]}
    />
    <ReferenceArrayInput
      label={"resources.accounts.fieldList.users"}
      source="users"
      reference="users"
      allowEmpty
    >
      <SelectArrayInput optionText={userOptionTextFormatter} />
    </ReferenceArrayInput>
    <ReferenceArrayInput
      label={"resources.accounts.fieldList.campaigns"}
      source="campaigns"
      reference="campaigns"
      allowEmpty
    >
      <SelectArrayInput optionText="name" />
    </ReferenceArrayInput>
  </OlaForm>
);

export const AccountCreate = props => (
  <Create
    {...props}
    title={<IconTitle icon="accounts" title={"resources.accounts.title"} />}
  >
    <AccountForm {...props} />
  </Create>
);

export const AccountEdit = props => (
  <Edit
    {...props}
    title={<IconTitle icon="accounts" title={"resources.accounts.title"} />}
  >
    <AccountForm {...props} />
  </Edit>
);



// WEBPACK FOOTER //
// ./src/accounts/Create.js